var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector83(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 341,
    height: 319,
    viewBox: "0 0 341 319",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M340.127 318.366C315.89 298.765 312.049 294.496 296.695 274.383C292.933 269.456 287.014 259.876 281.361 248.044C279.667 244.504 278.13 240.992 276.722 237.53C266.676 212.755 265.258 185 267.592 157.59C273.551 87.651 235.693 24.5283 178.375 6.12656C120.948 -12.3244 57.1983 18.0076 26.0867 65.325C22.039 71.4818 4.18362 100.535 1.54421 132.411C-6.81719 233.055 90.6734 273.272 239.012 303.722C241.898 304.312 255.636 306.564 258.551 306.967L340.137 318.366H340.127Z",
    stroke: "#1E1E22",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector83);
export default __webpack_public_path__ + "static/media/vector8-3.692a9fcd093fe2e50edd1ab95c31bfaf.svg";
export { ForwardRef as ReactComponent };